// PRC-028: página no encontrada dentro de la aplicación (con el menú) y error
// del programa (`errorElement`). Bloque de estado del recorrido (PRC-015).
import React from 'react';
import { Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { JourneyButton } from '../components/JourneyBasics';
import { StatusBlock } from '../components/JourneyBlocks';
import { SimpleLayout } from '../components/JourneyLayouts';
import { safeOrigin } from '../navigation';

export const AppNotFoundPage: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box sx={{ px: { xs: 2, md: 4 }, py: { xs: 4, md: 8 }, display: 'flex', justifyContent: 'center' }}>
      <Box sx={{ width: '100%', maxWidth: 560 }}>
        <StatusBlock
          variant="info"
          centered
          title="No encontramos esta página"
          text="La dirección no existe o ha cambiado. Sigue desde Overview o usa el menú."
          actions={<JourneyButton onClick={() => navigate('/margin-center/overview')}>Ir a Overview</JourneyButton>}
        />
      </Box>
    </Box>
  );
};

// Se muestra fuera de los layouts: no depende de la sesión ni del contexto.
export const AppErrorPage: React.FC = () => {
  const inPricing = safeOrigin(window.location.pathname) !== null;
  return (
    <SimpleLayout narrow>
      <StatusBlock
        variant="error"
        centered
        title="Algo ha fallado"
        text="La pantalla no se ha podido mostrar. Vuelve a intentarlo; si se repite, escríbenos a soporte@proapricing.ai."
        actions={(
          <>
            <JourneyButton onClick={() => window.location.reload()}>Reintentar</JourneyButton>
            {inPricing
              ? <JourneyButton kind="ghost" onClick={() => window.location.assign('/margin-center/overview')}>Ir a Overview</JourneyButton>
              : <JourneyButton kind="ghost" onClick={() => window.location.assign('/')}>Ir al inicio</JourneyButton>}
          </>
        )}
      />
    </SimpleLayout>
  );
};
